import React from 'react'
import { Link } from 'react-router-dom'

function Socials() {
  return (
    <div className='version'>
        <div className="version-divs">
            <h2>SOCIAL</h2>
            <ul>
                <li><Link to="https://www.linkedin.com/in/bibhu-ni" target="_blank" rel="noreferrer">Linkedin</Link></li>
                <li><Link to="https://github.com/Bibhuni" target="_blank" rel="noreferrer">Github</Link></li>
                <li><Link to="https://www.facebook.com/people/Bibhu-Prasad-Sahoo/100007464406805/" target="_blank" rel="noreferrer">Facebook</Link></li>
                <li><Link to="https://www.instagram.com/beee_vu/" target="_blank" rel="noreferrer">Instagram</Link></li>
                <li><Link to="https://twitter.com/Bibhupr77888" target="_blank" rel="noreferrer">Twitter</Link></li>
            </ul>
        </div>
    </div>
  )
}

export default Socials
